import { IconButton } from '@mui/material';
import { forwardRef } from 'react';

export const IconButtonRounded = forwardRef(({ children, ...props }, ref) => {
  return (
    <IconButton
      ref={ref}
      {...props}
      sx={{
        borderRadius: '12px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale(1.05)',
        },
        ...props.sx,
      }}
    >
      {children}
    </IconButton>
  );
});

IconButtonRounded.displayName = 'IconButtonRounded';
